var _defs, _g, _path, _path2, _path3, _path4, _path5, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardiacSurgery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 25.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffb3bc;}.cls-1,.cls-2,.cls-3,.cls-4{stroke:#2c355e;stroke-width:0.25px;}.cls-1,.cls-4{stroke-linecap:round;stroke-linejoin:round;}.cls-2{fill:#4491e4;}.cls-2,.cls-3{stroke-miterlimit:10;}.cls-3{fill:#fff;}.cls-4,.cls-5{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cardiac Surgery") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "yy7zpZ"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DicFnD"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.27,13.91a13.08,13.08,0,0,0-1.62.13s-.05-.15-.09-.25a3.63,3.63,0,0,0-2.82-2.48,5.62,5.62,0,0,0-3.26.38l-.17.08a5.51,5.51,0,0,0-1.68,1.41h0a1.62,1.62,0,0,1-.1.18,5.28,5.28,0,0,0-.45,1,4.65,4.65,0,0,0,.74,4,19.9,19.9,0,0,0,3.65,3.91,14.3,14.3,0,0,0,2.92,2,2.16,2.16,0,0,0,3.06-.54,12.5,12.5,0,0,0,3.06-5.87A3.25,3.25,0,0,0,16.27,13.91Z",
    transform: "translate(0 -0.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.79,5.56A1.81,1.81,0,0,1,3,5.74L7.17,11c.15.19.13.32-.06.45l-.39.31c-.28.22-.33.22-.55-.06L3.2,8,2.13,6.61c-.27-.34-.27-.37.07-.63.13-.1.25-.21.39-.3A1.17,1.17,0,0,1,2.79,5.56Z",
    transform: "translate(0 -0.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.68,20.84a2.59,2.59,0,0,1-.36-.22c-.2-.18-.38-.37-.56-.56s-.29-.24-.53,0-.36.37-.54.54-.49.25-.67.06a.45.45,0,0,1,.05-.66l.52-.52c.27-.28.28-.3,0-.57s-.37-.35-.54-.54a.43.43,0,0,1,0-.65.44.44,0,0,1,.63,0c.21.21.42.41.62.62a.24.24,0,0,0,.41,0c.21-.21.41-.42.62-.62A.45.45,0,0,1,15,17.7a.43.43,0,0,1,0,.65q-.3.31-.6.6a.27.27,0,0,0,0,.46,4.76,4.76,0,0,1,.63.64.6.6,0,0,1,.08.47C15,20.64,14.81,20.73,14.68,20.84Z",
    transform: "translate(0 -0.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.27,16.22a4.13,4.13,0,0,1-.57-.11,3.34,3.34,0,0,1-1.47-.76c-.49-.46-.94-1-1.4-1.48a.22.22,0,0,1,0-.37l.6-.47c.17-.15.27,0,.37.1L11,15.88Z",
    transform: "translate(0 -0.95)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.54,6.78c2.33-2.35,6.8-1.17,6.8-1.17a8.93,8.93,0,0,0-1.92-1.17s1-1.7.34-2.4-1.44.13-1.66,1.29-1,.27-1,.27c-1.41-2.12-3.78-3.25-4.61-2s1.25,1.69,1.43,2.84a2.23,2.23,0,0,1-1,2s-.91-2.14-2-1.61-.46,1.57-.47,2.73-1.6,1.71-1.6,1.71,1.17,1.35,4.3,1.16A5.46,5.46,0,0,1,12.54,6.78Z",
    transform: "translate(0 -0.95)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.79,10.28a7.27,7.27,0,0,1,4.76,2.83s2.79-.36,3.62,3.53a5.16,5.16,0,0,0,1.08-3.7A6.31,6.31,0,0,0,18.77,9.5a3.8,3.8,0,0,1,1.82-.11c.91.21,2.18-2,.72-2.9S13.5,6.8,11.79,10.28Z",
    transform: "translate(0 -0.95)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.88,12.3s.16-2.22,1.89-2.8",
    transform: "translate(0 -0.95)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M16.1,3.33S16,4.82,12.44,5.56",
    transform: "translate(0 -0.95)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.35,13.83a5.08,5.08,0,0,1,.55-1.3L5,11.41A3.09,3.09,0,0,0,5.35,13.83Z",
    transform: "translate(0 -0.95)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 1.05,
    width: 26,
    height: 24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardiacSurgery);
export default __webpack_public_path__ + "static/media/cardiac_surgery.836f7344a079d30abbfef8e1ea4eebd2.svg";
export { ForwardRef as ReactComponent };